//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  danger,
  success,
} from '@/utils/notify'
import TInput from '@/TShareComponent/TInput'

export default {
  components: { TInput },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    params: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return { verificationCode: '' }
  },

  async created () {
  },

  methods: {
    async getValidateCode () {
      this.$refs.countDownBtn.countDown()

      const { code, message } = await this.params.apiMethod(this.params.sjh)

      if (+code === 0) {
        success('发送成功，请查看手机消息！')
      } else {
        danger(message)
      }
    },
  },
}
